import consumer from "./consumer"

let searchEntitiesConnected = false;

// Rails UJS fires this before it sends the POST. Prepare the results container
// here, rather than on AJAX success: the worker can finish before the POST does.
document.addEventListener('ajax:before', (event) => {
  const form = event.target;
  if (form.id !== 'quick_search_entities') return;

  if (!searchEntitiesConnected) {
    event.preventDefault();
    toastr.error('Search connection is not ready. Please try again in a moment.');
    return;
  }
  if (form.dataset.searchPending === 'true') {
    event.preventDefault();
    return;
  }

  form.dataset.searchPending = 'true';
  document.getElementById('entities_results').innerHTML =
    'Searching entities... <span class="spinner-border spinner-border-sm" role="status"></span>';
});

document.addEventListener('ajax:error', (event) => {
  const form = event.target;
  if (form.id !== 'quick_search_entities') return;

  delete form.dataset.searchPending;
  const data = event.detail[0];
  const message = data && Array.isArray(data.errors) ? data.errors.join('. ') :
    'Unable to start the search. Please try again.';
  document.getElementById('entities_results').textContent = message;
  toastr.error(message);
});

consumer.subscriptions.create("SearchEntitiesChannel", {
  connected() {
    searchEntitiesConnected = true;
  },

  disconnected() {
    searchEntitiesConnected = false;
  },

  rejected() {
    searchEntitiesConnected = false;
  },

  received(data) {
    if (data.type == 'quick_search_entities_ready') {
      const form = document.getElementById('quick_search_entities');
      toastr.success('Quick Search Entities has finished');
      // This user-wide broadcast also reaches tabs displaying other views.
      // Visual Search shares the results ID, so require the Quick Search form too.
      const results = document.getElementById('entities_results');
      if (!form || !results) return;

      delete form.dataset.searchPending;
      if (data.html != null) {
        $(`#entities_results`).html(data.html);
        $('html, body').animate({
          scrollTop: $(`#entities_results`).offset().top
        }, 1000);
      } else if (data.csv != null) {
        $(`#entities_results`).html('');
        var blob = new Blob([data.csv], {type: 'text/csv'});
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'quick_search_entities.csv';
        document.body.append(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL;
      } else {
        toastr.success('Results sent to your email. Please check your inbox.');
        $(`#entities_results`).html('');
      }
    } else if (data.type == 'graph_search_entities_ready') {
      toastr.success('Graph Search Entities has finished');
      if (data.html != null) {
        let container = document.getElementById('entities_results');
        if (container != null && container.getAttribute('data-graph-id') == data.graph_id) {
          $(`#entities_results`).html(data.html);
          renderEntitiesRelationship(document.getElementById('entities_results').getElementsByClassName('graph-container')[0]);
        }
      } else {
        console.log('No data received');
      }
    } else if (data.type == 'graph_search_entities_error') {
      let container = document.getElementById('entities_results');
        if (container != null && container.getAttribute('data-graph-id') == data.graph_id) {
          toastr.error('EntitiesVisual Search has failed');
          $(`#entities_results`).html('');
        }
    }
  }
});
